import {athubAxios} from "../../../util/athub-axios";

const position = {
    page: page,
    add: add,
    update: update,
    remove: remove,
    checkName: checkPositionNameAvailable,
    findById: findById,
    positionOptions: positionOptions,
    valid: valid,
    invalid: invalid,
};

export default position;

import {ORGANIZATION_SERVER} from '@/api/server'

/**
 * 条件查询职位列表分页信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function page(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/position/page`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 获取所有职位options
 */
export function positionOptions() {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/position/options`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 添加职位信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/position`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 检查岗位名称是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkPositionNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/position/check/name`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 修改职位信息
 * @param id 职位ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/position/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 删除职位信息
 * @param id 职位ID
 * @returns {Promise<unknown>}
 */
export function remove(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.delete(`${ORGANIZATION_SERVER}/position/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 根据职位ID查询职位详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/position/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 启用
 * @param params
 * @returns {Promise<unknown>}
 */
export function valid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/position/${id}/valid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 停用
 * @param params
 * @returns {Promise<unknown>}
 */
export function invalid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/position/${id}/invalid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}